var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-3 py-2" },
    [
      !_vm.error
        ? _c("b-table", {
            staticClass: "shx-table w-100",
            attrs: {
              busy: _vm.fetching,
              items: _vm.rows,
              fields: _vm.columns,
              hover: "",
              dark: "",
              fixed: "",
              small: "",
              "sort-icon-left": "",
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(admissions)",
                  fn: function (data) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatInt(data.item.admissions))),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(real_weighted)",
                  fn: function (data) {
                    return [
                      _vm.bucket === "week"
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  data.item.real_weighted !== null
                                    ? data.item.real_weighted + "%"
                                    : "—"
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.bucket === "week" &&
                      data.item.real_weighted !== null &&
                      data.item.real_weighted <= 90
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: {
                                title:
                                  "Minimum real: " + data.item.real_min + "%",
                              },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "cell(actions)",
                  fn: function (data) {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link btn-sm",
                          on: { click: data.toggleDetails },
                        },
                        [
                          _c("icon", {
                            attrs: {
                              name:
                                "chevron-" +
                                (data.detailsShowing ? "up" : "down"),
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "row-details",
                  fn: function (data) {
                    return [
                      _c("admissions-titles-table", {
                        attrs: {
                          bucket: _vm.bucket,
                          "parent-key": _vm.parentKey,
                          "theatre-code": data.item.theatre_code,
                          saleshouse: _vm.saleshouse,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "table-busy",
                  fn: function () {
                    return [_c("table-spinner")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3106154965
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "text-center text-muted py-3" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : !_vm.fetching && !_vm.rows.length
        ? _c("div", { staticClass: "text-center text-muted py-3" }, [
            _vm._v("No cinemas."),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }